export const number = (val?: number | null, fallback?: string | number) =>
  val ?? fallback ?? 0;
export const string = (val?: string | null, fallback?: string) =>
  val ?? fallback ?? '';
